import { action, observable } from 'mobx';

import { ConnectionAppManager, Variables } from 'core/index';

import { CommentArrayApp } from 'apps/comments/app';
import { CommentsQuery, CommentMutation } from 'apps/comments/gql';

export class CommentConnManager extends ConnectionAppManager {
  static ArrayApp = CommentArrayApp;
  @observable deletedComments = 0;
  constructor(parent, init) {
    super(parent, init);
    this.initialBatchSize = 25;
    this.batchSize = 50;
    this.variables = new Variables({
      sortBy: () => '-recent',
      origin: () => this.content?.id,
      cursor: () => this.endCursor,
      batchSize: () => {
        if (this.loadedMore) {
          return this.batchSize;
        }
        return this.initialBatchSize;
      },
    });
    this.loadMoreQuery = CommentsQuery;
    this.loadMore();
  }

  @action NewSlug() {
    this.Reset();
  }

  @action SetSort(sort) {
    this.sortBy = sort;
    this.Clear();
    this.loadMore();
  }

  @action UpdateComment = (input, options) => {
    this.mutations.push(CommentMutation.New(input, options));
  };
}
